import styled from 'styled-components'

export const Container = styled.div`
  margin: 0px 0px;
  border: 1px solid ${({ theme }) => theme.ds.colors.neutral100};
`
